import { StyleSheet, View, Text } from "react-native";
import { timeValue, getSchemeStyle } from "../context/helper";
import RSSIImage from "./RSSIImage";
import SimplePress from "./SimplePress";
import { Feather } from "./VectorIcons";

function MessdatenItem({ item, remark, isSelected, onPress }) {
  const schemeStyles = getSchemeStyle();
  const RSSISize = 18;

  return (
    <SimplePress onPress={onPress || (() => {})}>
      <View style={[styles.messItem, schemeStyles.Border, isSelected && styles.selectedItem]}>
        <View style={styles.messTextContainer}>
          <Text
            style={[
              styles.messText,
              styles.mainText,
              schemeStyles.defaultText,
              item.item.error && schemeStyles.errorText,
            ]}
          >
            {timeValue(item.item.time)}
          </Text>
          <Text
            style={[
              styles.messText,
              schemeStyles.defaultText,
              item.item.error && schemeStyles.errorText,
            ]}
          >
            {item.item.value === -99
              ? "---"
              : `${item.item.value}${item.item.unit}`}
          </Text>
          <Text
            style={[
              styles.messText,
              schemeStyles.defaultText,
              item.item.error && schemeStyles.errorText,
            ]}
          >
            {item.item.voltage}V
          </Text>
          <Text
            style={[
              styles.messText,
              schemeStyles.defaultText,
              item.item.error && schemeStyles.errorText,
            ]}
          >
            {item.item.rssi === 0 ? "---" : `${item.item.rssi}dBm`}
          </Text>
          <View style={styles.rssiImage}>
            <RSSIImage
              size={RSSISize}
              rssi={item.item.rssi}
              goodColor={schemeStyles.rssiImage.goodColor}
              weakColor={schemeStyles.rssiImage.weakColor}
              badColor={schemeStyles.rssiImage.badColor}
              doincrease={schemeStyles.rssiImage.doincrease}
            />
          </View>
          <View style={styles.remarkIcon}>
            {!!remark && (
              <Feather name="message-square" size={16} color="#4785b8" />
            )}
          </View>
        </View>
      </View>
    </SimplePress>
  );
}

export default MessdatenItem;

const styles = StyleSheet.create({
  messItem: {
    marginHorizontal: 4,
    paddingVertical: 2,
    borderRadius: 4,
    borderBottomWidth: 1,
  },
  messTextContainer: {
    padding: 4,
    flexDirection: "row",
    alignItems: "center"
  },
  messText: {
    fontFamily: "Roboto-MediumItalic",
    fontSize: 12,
    flex: 2,
    textAlign: "right",
  },
  mainText: {
    flex: 6,
    textAlign: "left",
  },
  rssiImage: {
    marginLeft: 5,
  },
  remarkIcon: {
    width: 18,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 4,
  },
  selectedItem: {
    backgroundColor: "#4785b828",
  },
});
